export const MESSAGES_KEY = 'translations';
export const MESSAGES_HEADER_KEY = 'translation-version';
